import React from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";

import AuthLayout from "../../layouts/AuthLayout";
import FormField from "../../components/FormField";
import { USERS_TYPE } from "../../data/Constants";
import RippleButton from "../../components/buttons/RippleButton";
import { login } from "../../redux/slices/authSlice";

const SignIn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.auth.loading);

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required")
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email address"),
        password: Yup.string().required("Password is required"),
    });

    const initialValues = {
        email: "",
        password: "",
    };

    return (
        <AuthLayout rightContainerClassName="mt-226-sigin">
            <section>
                <h5 className="fs-22 fw-600 text-gray-900">Sign In</h5>
            </section>
            <section style={{ marginTop: "22px" }}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        const user = { ...values };
                        user["user_type"] = USERS_TYPE.ADMIN;
                        dispatch(login({ user, navigate }));
                    }}
                >
                    {() => (
                        <Form className="row">
                            <FormField label="User ID - Email Address" name="email" type="email" fieldSize="col-12" labelFontColor="text-gray-950" footerPlaceholder="Please enter your email" />
                            <FormField
                                label="Password"
                                name="password"
                                type="password"
                                fieldSize="col-12"
                                isForgotPasswordField={true}
                                labelFontColor="text-gray-950"
                                footerPlaceholder="Please enter your password"
                            />
                            <div className="d-flex justify-content-end auth-login-button">
                                <RippleButton type="submit" isLoading={loading}>
                                    Login
                                </RippleButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </section>
        </AuthLayout>
    );
};

export default SignIn;
